function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import Typed from "typed.js";
import classNames from "classnames";
import DefaultProps from "./default-props";
import { StylesTypedComponent } from "./typed-component.scss";
const TypedComponent = (props)=>{
    const { typedProps, className, style, stopped } = props;
    const [timeElapsed, setTimeElapsed] = useState(0);
    const el = useRef(null);
    const typed = useRef(null);
    useEffect(()=>{
        typed.current = new Typed(el.current, _object_spread({}, DefaultProps.typedProps, typedProps));
        return ()=>{
            typed.current.destroy();
        };
    }, []);
    useEffect(()=>{
        if (stopped) {
            typed.current.stop();
        } else {
            const { startDelay = 0 } = typedProps;
            const startTime = performance.now();
            // Debouncing start if stopped in the proccess
            const delayTime = Math.max(0, startDelay - timeElapsed);
            const handler = setTimeout(()=>typed.current.start(), delayTime);
            return ()=>{
                const endTime = performance.now();
                const newTimeElapsed = timeElapsed + endTime - startTime;
                setTimeElapsed(newTimeElapsed);
                clearTimeout(handler);
            };
        }
    }, [
        stopped
    ]);
    return /*#__PURE__*/ _jsx(StylesTypedComponent, {
        className: classNames("typed-component", className),
        style: style,
        children: /*#__PURE__*/ _jsx("span", {
            className: "content",
            ref: el
        })
    });
};
export default TypedComponent;
TypedComponent.defaultProps = DefaultProps;
